import PropTypes from "prop-types";
import { createDish, getDishId } from "../../../../utils/model/dish";
import DishCreator from "./dish/DishCreator";

const MenuCreator = ({dishes, setDishes}) => {
    const addDishClickHandler = () => setDishes([...dishes, createDish()]);
    const handleDishInfoChange = (id, name, value) => {
        const newDishes = dishes.map(
            (dish) => (getDishId(dish) === id) ? {...dish, [name]: value} : dish
        );
        setDishes(newDishes);
    }
    const handleRemoveDish = (id) => {
        const newDishes = dishes.filter((dish) => getDishId(dish) !== id);
        setDishes(newDishes);
    }
    return (
        <div className="dish-list">
            {dishes.map((dish, dishIndex) => (
                <DishCreator
                    key={`dish_input_${getDishId(dish)}`}
                    index={dishIndex}
                    dish={dish}
                    onDishChange={handleDishInfoChange}
                    onRemoveClick={handleRemoveDish}
                />
            ))}
            <button
                onClick={addDishClickHandler}
                className="default-button"
            >
                Add one more
            </button>
        </div>
    )
};

MenuCreator.propTypes = {
    dishes: PropTypes.array.isRequired,
    setDishes: PropTypes.func.isRequired
}

export default MenuCreator;
